








import {
  createComponent,
  inject,
  onMounted,
  computed
} from "@vue/composition-api";

import DisplayUIKey from "@/components/display-ui-key";
import LoginKey from "@/components/login-key";
import LoginScreen from '@/components/templates/Auth/LoginScreen.vue'
import HeaderLogin from '@/components/templates/Auth/HeaderLogin.vue'
import LoginInformation from '@/components/templates/Auth/LoginInformation.vue'
import LoginFooter from '@/components/templates/Auth/LoginFooter.vue'
import router from '../../router'
export default createComponent({
  setup(props,context) {
    const displayui = inject(DisplayUIKey);
    if (!displayui) {
      throw new Error(`${DisplayUIKey} is not provided`);
    }
    const login = inject(LoginKey);
    if (!login) {
      throw new Error(`${LoginKey} is not provided`);
    }
    onMounted(() => {
      const tokenComany = context.root.$route.query.token as any
      if(tokenComany){
        window.localStorage.setItem("token","JWT " + tokenComany)
        router.push("/company_detail", () => {})
      }else if(window.localStorage.getItem('token')){
        context.root.$router.push('/company_detail',() => {})
      } else {
        router.push('/', () =>{})
      }
    })


  },
  
  components: {
    LoginScreen,
    HeaderLogin,
    LoginInformation,
    LoginFooter
  }
 

})
